module.exports = __webpack_public_path__ + "static/media/chattyLogoLight.6ad8e1a7.png";